import { useState } from 'react';
import SearchableListWithChips from 'components/SearchableListWithChips';
import CollapseSection from 'views/root/views/home/views/settings/components/CollapseSection';
import {
  ChipComponent,
  ListItem
} from 'views/root/views/home/views/settings/views/EmailPreferences/SearchListComponents';
import { StyledFormItem } from '../FormItems/FormItems.style';
import TotalSelectedTitle from '../TotalSelectedTitle';
import useUsersQuery from './useUsersQuery';

const formatUsers = (users, disabled) => {
  const formattedUsers = users.filter(Boolean).map(user => ({
    ...user,
    avatarUrl: user?.avatar_url,
    isDisabled: disabled,
    view: (
      <ListItem
        key={user.id}
        name={user.name}
        email={user.email}
        avatarUrl={user?.avatar_url}
      />
    )
  }));

  return formattedUsers;
};

const UsersPicker = ({
  collapsable = false,
  selectedUsers,
  setSelectedUsers,
  disabled = false,
  limit,
  isTitleClickable
}) => {
  const [searchKeyword, setSearchKeyword] = useState('');

  const { data: users = [], isLoading } = useUsersQuery({
    limit: 50,
    search: searchKeyword
  });

  const isDisabled = !!limit && selectedUsers.length >= limit;
  const formattedUsers = formatUsers(users, isDisabled);

  return (
    <CollapseSection
      title={isOpen => (
        <TotalSelectedTitle
          title='Direct Users'
          total={selectedUsers?.length}
        />
      )}
      pl='medium'
      openButtonText='View & edit'
      isCollapsable={collapsable}
      isTitleClickable={isTitleClickable}
    >
      <div className='mb-1 mt-2'>
        <StyledFormItem disabled={disabled}>
          <SearchableListWithChips
            chip={ChipComponent}
            placeholder='Search users'
            searchKeys={['name', 'id']}
            items={formattedUsers}
            onSelectItem={item => {
              setSelectedUsers([...selectedUsers, item]);
            }}
            onRemoveItem={item => {
              setSelectedUsers(
                selectedUsers.filter(user => user.id !== item.id)
              );
            }}
            selectedItems={formatUsers(selectedUsers)}
            searchKeyword={searchKeyword}
            setSearchKeyword={setSearchKeyword}
            isLoading={isLoading}
          />
        </StyledFormItem>
      </div>
    </CollapseSection>
  );
};
export default UsersPicker;
